// extracted by mini-css-extract-plugin
export default {"blurbWrapper":"FeatureBenefits_blurbWrapper__-h-RT","benefitsBlurb":"FeatureBenefits_benefitsBlurb__t9fo3","benefitBlendsContainer":"FeatureBenefits_benefitBlendsContainer__VzPEh"};